import { Box, Button, Container, Heading, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { RiCheckboxCircleFill, RiErrorWarningFill } from 'react-icons/ri'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <Container h='90vh' p='16'>
        <VStack justifyContent={'center'} h='full' spacing={'4'}>
        <RiErrorWarningFill size={'5rem'}/>
        <Heading my='8' textAlign={'center'} children='The route doesnt exist vro' />
            <Link to="/">
                <Button variant='outline'>
                    Go to Home
                </Button>
            </Link>
        </VStack>
    </Container>
  )
}

export default NotFound